import React, { forwardRef } from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import mixins from '../../assets/styles/mixins.scss';

const useStyles = makeStyles({
  root: {
    padding: 16,
    borderRadius: 8,
    boxSizing: 'border-box',
    backgroundColor: mixins.chalkWhiteFont,

    '& *': {
      boxSizing: 'border-box'
    }
  }
});

/**
 * To update styles, use the classes prop
 *
 * @example
 * <CustomCard
 *   classes={{
 *     root: classes.yourClassName
 *   }}
 * >
 *   {children}
 * </CustomCard>
 *
 * @param {Object} props
 * @returns {React.Component} - A custom card component
 */

const CustomCard = forwardRef((props, ref) => {
  const {
    backgroundColor,
    children,
    style,
    className,
    isButtonCard = false,
    onClick
  } = props;
  const classes = useStyles(props);

  if (isButtonCard) {
    return (
      <Button
        classes={{ label: `${classes.root} ${className}` }}
        style={{
          backgroundColor,
          ...style
        }}
        onClick={onClick}
      >
        {children}
      </Button>
    );
  }

  return (
    <div
      ref={ref}
      className={`${classes.root} ${className}`}
      style={{
        backgroundColor,
        ...style
      }}
    >
      {children}
    </div>
  );
});

CustomCard.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
  isButtonCard: PropTypes.bool,
  onClick: PropTypes.func
};

CustomCard.defaultProps = {
  backgroundColor: '',
  children: null,
  style: {},
  className: '',
  isButtonCard: false,
  onClick: () => {}
};

export default CustomCard;
